import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Button } from '../../components/Button';

import { handleLogout } from '../../actions/users';
import { WHITE, GREY, PRIMARY, TEXT } from '../../constants/colors';
import { companyLogoUrl } from '../../services/companyLogoUrl';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  color: ${TEXT};
`;

const ContentWrapper = styled.div`
  width: calc(100% - 250px);
  height: 100%;
`;

const NavigationWrapper = styled.div`
  width: 250px;
  height: 100%;
  background-color: ${WHITE};
  box-shadow: 0 5px 13px 0 rgba(0, 0, 0, 0.14);
  z-index: 1;
  position: relative;
`;

const LinkWrapper = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  text-align: center;

  > a {
    height: 100%;
    text-decoration: none;
    font-size: 14px;
    cursor: pointer;
    padding: 10px;
    border-bottom: 1px solid ${GREY};
    color: ${TEXT};
    & :hover {
      color: ${PRIMARY};
    }
  }

  > * {
    width: calc(100% / 3);
  }

  .disabled {
    color: ${GREY};
    pointer-events: none;
  }

  .active {
    border-bottom: 1px solid ${PRIMARY}!important;
    color: ${PRIMARY};
  }
`;

const NavigationContentWrapper = styled.div`
  width: 100%;
  height: calc(100% - 40px);
`;

const LogoutButton = styled.div`
  width: 86%;
  padding: 0 0 10px;
  position: absolute;
  left: 10px;
  bottom: 0;
  background-color: ${WHITE};
`;

class Layout extends Component {
  render() {
    const {
      navigation, content, handleLogout, selectedElement, user,
    } = this.props;

    return (
      <Wrapper>
        <NavigationWrapper>
          <div style={{width: '100%', textAlign: 'center'}}>
            {companyLogoUrl(user.company)}
          </div>
          <LinkWrapper>
            <Link
              className={window.location.pathname === '/' ? 'active' : ''}
              to="/"
            >
              Home
            </Link>
            <Link
              className={window.location.pathname.includes('/element') ? 'active' : (!selectedElement ? 'disabled' : '')} // eslint-disable-line
              to={`/element/${selectedElement ? selectedElement.id : 'null'}`}
            >
              Preview
            </Link>
            <Link
              className={window.location.pathname === '/admin' ? 'active' : (!user.admin ? 'disabled' : '')} // eslint-disable-line
              to="/admin"
            >
              Admin
            </Link>
          </LinkWrapper>
          <NavigationContentWrapper>
            {navigation}
            <LogoutButton>
              <Button
                block
                onClick={handleLogout}
              >
                Logout
              </Button>
            </LogoutButton>
          </NavigationContentWrapper>
        </NavigationWrapper>
        <ContentWrapper>
          {content}
        </ContentWrapper>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users,
    selectedElement: state.elements.selectedElement,
    error: state.elements.error,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    handleLogout,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);



// WEBPACK FOOTER //
// ./src/containers/Layout/index.js